import styled, { css, DefaultTheme } from 'styled-components';
import { ButtonProps } from '.';

type ContainerProps = {
  disabled?: boolean;
  height?: number;
  fontSize?: number;
} & Pick<ButtonProps, 'secondary' | 'tertiary' | 'link'>;

const ContainerModifier = {
  disabled: (theme: DefaultTheme) => css`
    background: ${theme.colors.colorGray300};
    color: ${theme.colors.colorGray400};
  `,
  secondary: (theme: DefaultTheme) => css`
    background: #fff;
    color: ${theme.colors.blueEinstein};
    border: 1px solid ${theme.colors.blueEinstein};
  `,
  tertiary: (theme: DefaultTheme) => css`
    background: #fff;
    color: ${theme.colors.blueEinstein};
  `,
  link: (theme: DefaultTheme) => css`
    width: initial;
    height: initial;
    background: transparent;
    color: ${theme.colors.blueEinstein};
    font-size: 16px;
  `
};

export const Container = styled.button<ContainerProps>`
  ${({ theme, secondary, tertiary, disabled, link, height, fontSize }) => css`
    width: 100%;
    height: ${height ? `${height}px` : '56px'};
    background: ${theme.colors.blueEinstein};
    color: #fff;
    border: 0;
    border-radius: 3rem;
    font-size: ${fontSize ? `${fontSize}px` : '18px'};
    font-weight: 600;
    cursor: pointer;
    font-family: 'Montserrat', sans-serif;

    ${secondary && ContainerModifier.secondary(theme)}
    ${tertiary && ContainerModifier.tertiary(theme)}
    ${disabled && ContainerModifier.disabled(theme)}
    ${link && ContainerModifier.link(theme)}

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 16px;

    & + & {
      margin-top: 16px;
    }
  `}
`;

export const IconWrapper = styled.div`
  img {
    width: 24px;
    height: 24px;
  }
`;
